<div class="user-summary">
  @for (card of cards; track card.key) {
    <div
      class="user-summary__card"
      [class.is-selected]="selected === card.key"
      [style.border-left-color]="card.accent"
      role="button"
      tabindex="0"
      [attr.aria-pressed]="selected === card.key"
      (click)="selectCard.emit(card.key)"
      (keydown.enter)="selectCard.emit(card.key)"
      (keydown.space)="selectCard.emit(card.key)">
      <div class="user-summary__header">
        <div class="user-summary__heading">
          <h3>{{ card.title }}</h3>
          <p>
            <span
              class="pi pi-question-circle"
              [pTooltip]="card.help"
              tooltipPosition="top"
              (click)="$event.stopPropagation()"></span>
            Usuários
          </p>
        </div>
        <span
          class="user-summary__icon"
          [style.color]="card.accent"
          [style.background]="card.accent + '1a'">
          <i class="pi" [ngClass]="card.icon"></i>
        </span>
      </div>
      <div class="user-summary__value">
        @if (countOf(card.key) === null) {
          <span class="user-summary__skeleton" aria-hidden="true"></span>
        } @else {
          {{ countOf(card.key) }}
        }
      </div>
      <div class="user-summary__footer">{{ card.footer }} <i class="pi pi-arrow-right"></i></div>
    </div>
  }
</div>
